import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import ProductCard from "../Product/ProductCard";
import "./ProductSwiper.css";

const ProductSwiper = ({ products, addToCart }) => {
  return (
    <div className="product-swiper-container">
      <h2 className="swiper-title">Daily Essentials</h2>
      <Swiper
        modules={[Autoplay, Pagination, A11y]}
        loop={true} // 👈 enable continuous loop
        speed={800} // 👈 smoother transitions
        loopedSlides={products.length} // 👈 help with seamless loop
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        grabCursor
        spaceBetween={24}
        breakpoints={{
          0: { slidesPerView: 1.1 },
          480: { slidesPerView: 1.3 },
          640: { slidesPerView: 2 },
          768: { slidesPerView: 2.3 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
        className="products-swiper"
      >
        {products.map((product) => (
          <SwiperSlide key={product.id}>
            <ProductCard product={product} addToCart={addToCart} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ProductSwiper;
